import { render, staticRenderFns } from "./BlockAndFieldPermissions.vue?vue&type=template&id=9f9902b4&scoped=true"
import script from "./BlockAndFieldPermissions.vue?vue&type=script&lang=js"
export * from "./BlockAndFieldPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9902b4",
  null
  
)

export default component.exports